import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const IsraelFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15042'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15042)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 2.8H20V0H0V2.8Z'
					fill='#0E46D4'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V11.2H0V14Z'
					fill='#0E46D4'
				/>
				<path
					d='M7.32633 8.23682L7.04629 8.73081L7.62284 8.73081L12.3847 8.73081L12.9526 8.73081L12.6747 8.24067L10.2938 4.04067L9.99943 3.52148L9.70728 4.03682L7.32633 8.23682Z'
					stroke='#093EC5'
					strokeWidth='0.666667'
				/>
				<path
					d='M7.32633 5.76318L7.04629 5.26919L7.62284 5.26919L12.3847 5.26919L12.9526 5.26919L12.6747 5.75933L10.2938 9.95933L9.99943 10.4785L9.70728 9.96318L7.32633 5.76318Z'
					stroke='#093EC5'
					strokeWidth='0.666667'
				/>
			</g>
		</svg>
	);
};

export default IsraelFlagIcon;
